<template>
  <div class="d-flex gap-2" style="width: 100%;">
    <div style="width: 120px;">
      <label>{{ $t('account.country_code') }}</label>
      <SelectPhoneCode v-bind="{
        ...$attrs,
        'append-icon': undefined
      }"
      :phoneCode.sync="form.phoneCode"
      :countryCode.sync="form.countryCode"
      @onSelect="onSelectPhoneCode"
    />
    </div>
    <div style="width: 100%;">
      <label>{{ $t('account.phone_number') }}</label>
      <v-text-field
        ref="telField"
        v-model="form.tel"
        :placeholder="$t('account.phone_number')"
        :rules="[internalRules.numbersOnly, internalRules.phoneValid, ...rules]"
        @keypress="onNumberOnly"
        persistent-hint v-bind="$attrs"
        v-on="$listeners"
      >
      </v-text-field>
    </div>
  </div>
</template>
<script>
import SelectPhoneCode from "@/components/SelectPhoneCode.vue";
import parsePhoneNumber from 'libphonenumber-js'
export default {
  components: {
    SelectPhoneCode
  },
  props: {
    tel: String,
    interTel: String,
    isLabel: {
      type: Boolean,
      default: true,
    },
    rules: {
      type: Array,
      default: () => []
    },
    phoneLabel: {
      type: String,
      default: ''
    }
  },
  watch: {
    form: {
      deep: true,
      handler() {
        let interTel = ""
        let tel = ""
        if (this.form.tel) {
          interTel = parsePhoneNumber(this.form.phoneCode + this.form.tel)?.number
          tel = parsePhoneNumber(this.form.phoneCode + this.form.tel)?.format("NATIONAL").replace(/ /g, "")
        }
        this.$emit("update:tel", tel)
        this.$emit("update:interTel", interTel)
      }
    }
  },
  data() {
    return {
      form: {
        tel: this.tel,
        phoneCode: this.$globalCurrencyCode === "LAK" ? "+856" : "+66",
        countryCode: this.$globalCurrencyCode === "LAK" ? "LA" : "TH"
      },
      internalRules: {},
      phoneLabelInternal: '',
    }
  },
  computed: {
    isPhoneValid() {
      if (this.form.tel && this.form.phoneCode) {
        return parsePhoneNumber(this.form.phoneCode + this.form.tel)?.isValid()
      }
      return true
    }
  },
  created() {
    if (this.interTel && parsePhoneNumber(this.interTel)?.isValid()) {
      let parsed = parsePhoneNumber(this.interTel)
      this.form.phoneCode = `+${parsed.countryCallingCode}`
      this.form.countryCode = parsed.country
    }
    if (this.tel && parsePhoneNumber(this.tel, this.form.countryCode)?.isValid()) {
      let parsed = parsePhoneNumber(this.tel, this.form.countryCode)
      this.form.tel = parsed.nationalNumber
    }

    this.phoneLabelInternal = this.phoneLabel || this.$t('account.phone_number');

    this.internalRules = {
      numbersOnly: v => !v || /^\d+$/.test(v) || this.$t('validate.numbers_only'),
      phoneValid: v => !v || parsePhoneNumber(this.form.phoneCode + v)?.isValid() || this.$t('validate.phone_number_not_valid')
    };

  },
  methods: {
    onNumberOnly(evt) {
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (
        charCode > 31 &&
        (charCode < 48 || charCode > 57) &&
        charCode !== 46
      ) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    onSelectPhoneCode(e) {
      let temp = JSON.parse(JSON.stringify(this.form.tel))
      this.form.tel = ""
      this.$emit('onSelectPhoneCode', e)
      this.$nextTick(() => {
        this.form.tel = temp
      })
    },
    validate() {
      return this.$refs.telField.validate()
    }
  }
}
</script>